var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.993 17.042C27.48 13.017 24.054 10 19.996 10C15.938 10 12.506 13.021 11.997 17.051L10.866 26H15.1C15.563 28.282 17.581 30 20 30C22.419 30 24.437 28.282 24.9 26H29.136L27.993 17.042ZM20 28C18.694 28 17.583 27.165 17.171 26H22.829C22.417 27.165 21.306 28 20 28ZM13.134 24L13.981 17.302C14.364 14.272 16.941 12 19.996 12C23.051 12 25.623 14.268 26.009 17.295L26.864 24H13.134Z",
    fill: "#212337"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.67db5b4d06070d074a4f6b8e3be2e3b3.svg";
export { ForwardRef as ReactComponent };